
const state = {
    accToken: '',
    refToken: '',
    userInfo: {}
}

const mutations = {
    set(state, [variable, value]) {
        state[variable] = value;
    },
    saveUsrInfo(state, userInfo) {
        state.userInfo = userInfo
    },
    initData(state) {
        state.accToken = ''
        state.refToken = ''
        state.userInfo = {}
    }
};

const userStore = {
    namespaced: true,
    state,
    mutations
}

export default userStore